import pinRun from '../components/styles/assets/mapnode-laufen.svg'
import pinCycling from '../components/styles/assets/mapnode-biken.svg'
import pinRollerski from '../components/styles/assets/mapnode-rollerskifahren.svg'
import pinSkating from '../components/styles/assets/mapnode-inlineskaten.svg'
import pinSwimming from '../components/styles/assets/mapnode-schwimmen.svg'
import pinSkiing from '../components/styles/assets/mapnode-skifahren.svg'
import pinMulti from '../components/styles/assets/mapnode-multisport.svg'
import pinOcr from '../components/styles/assets/mapnode-ocr.svg'

import pinRunPremium from '../components/styles/assets/mapnode-laufen-premium.svg'
import pinCyclingPremium from '../components/styles/assets/mapnode-biken-premium.svg'
import pinRollerskiPremium from '../components/styles/assets/mapnode-rollerskifahren-premium.svg'
import pinSkatingPremium from '../components/styles/assets/mapnode-inlineskaten-premium.svg'
import pinSwimmingPremium from '../components/styles/assets/mapnode-schwimmen-premium.svg'
import pinSkiingPremium from '../components/styles/assets/mapnode-skifahren-premium.svg'
import pinMultiPremium from '../components/styles/assets/mapnode-multisport-premium.svg'
import pinOcrPremium from '../components/styles/assets/mapnode-ocr-premium.svg'

export function iconMapper(sportsType) {
  switch (sportsType) {
    case 'Laufen':
      return pinRun
    case 'Biken':
      return pinCycling
    case 'Schwimmen':
      return pinSwimming
    case 'Inlineskaten':
      return pinSkating
    case 'Skilaufen':
      return pinSkiing
    case 'Rollerskifahren':
      return pinRollerski
    case 'Multisport':
      return pinMulti
    case 'OCR':
      return pinOcr
    default:
    case 'Alle':
      return pinMulti
  }
}

export function iconMapperPremium(sportsType) {
  switch (sportsType) {
    case 'Laufen':
      return pinRunPremium
    case 'Biken':
      return pinCyclingPremium
    case 'Schwimmen':
      return pinSwimmingPremium
    case 'Inlineskaten':
      return pinSkatingPremium
    case 'Skilaufen':
      return pinSkiingPremium
    case 'Rollerskifahren':
      return pinRollerskiPremium
    case 'Multisport':
      return pinMultiPremium
    case 'OCR':
      return pinOcrPremium
    default:
    case 'Alle':
      return pinMultiPremium
  }
}

export function convertSportsForApi(sport) {
  switch (sport) {
    case 'Laufen':
      return 'L'
    case 'Biken':
      return 'B'
    case 'Schwimmen':
      return 'S'
    case 'Inlineskaten':
      return 'A'
    case 'Skilaufen':
      return 'I'
    case 'Rollerskifahren':
      return 'R'
    case 'Multisport':
      return 'M'
    case 'OCR':
      return 'O'
    default:
    case 'Alle':
      return 'LBSAIRMO'
  }
}

export function convertToMapSports(contestSport) {
  switch (contestSport) {
    case 'L':
      return 'Laufen'
    case 'B':
      return 'Biken'
    case 'S':
      return 'Schwimmen'
    case 'A':
      return 'Inlineskaten'
    case 'I':
      return 'Skilaufen'
    case 'R':
      return 'Rollerskifahren'
    case 'O':
      return 'OCR'
    default:
      return 'Multisport'
  }
}

export function fetchUrlParams() {
  let urlParams = {}
  const path = window.location.search.substring(1).split("&")
  path.forEach((param) => {
    const key = param.split("=")[0]
    const val = param.split("=")[1]
    if (key === "embedded") {
      urlParams.embedded = val === 'true';
    }
    if (key === "sport") {
      urlParams.sport = val;
    }
    if (key === "days") {
      urlParams.days = val;
    }
    if (key === "date") {
      if (/^[0-9]{2}-[0-9]{2}-[0-9]{4}$/.test(val)) {
        urlParams.date = val;
        urlParams.dateFormat = "DD-MM-YYYY"
      }
      else if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(val)) {
        urlParams.date = val;
        urlParams.dateFormat = "YYYY-MM-DD"
      }
    }
    if (key === "plz") {
      urlParams.plz = val;
    }
    if (key === "km") {
      urlParams.km = val;
    }
  })
  return urlParams
}



// WEBPACK FOOTER //
// ./src/utils/utilities.js